const init = () => {

    var $component = $('.c-title-bar');
    if (!$component.length) return;
    var titleBarHeight = 40;

    PubSub.subscribe('app:resized', onResize);

    function onResize() {
        _.each($component, function(el, i) {
            var $el = $(el);
            $el.toggleClass('is-wrapped', $el.height() > titleBarHeight);
        });
    }

}

export default init;